import { render } from "./Trial_Balance.vue?vue&type=template&id=48dc17e4"
import script from "./Trial_Balance.vue?vue&type=script&lang=js"
export * from "./Trial_Balance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__